import { render, staticRenderFns } from "./area_checkin.vue?vue&type=template&id=6cafbf84&scoped=true"
import script from "./area_checkin.vue?vue&type=script&lang=js"
export * from "./area_checkin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cafbf84",
  null
  
)

export default component.exports